var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoFilled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#info_filled_svg__clip0_15145_25905)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M8 14.667c1.84 0 3.507-.746 4.714-1.953A6.646 6.646 0 0 0 14.666 8c0-1.84-.746-3.507-1.952-4.714A6.646 6.646 0 0 0 8 1.333c-1.841 0-3.508.747-4.714 1.953A6.646 6.646 0 0 0 1.333 8c0 1.841.746 3.508 1.953 4.714A6.646 6.646 0 0 0 8 14.667Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M8 9.542V8.209a2 2 0 1 0-2-2"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "evenodd",
  d: "M8 12.542a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667Z",
  clipRule: "evenodd"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoFilled);
export default ForwardRef;